import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { request } from '../../interfaces/networkManager';
import { useEffect } from 'react';
import TabLogs from './part/TabLogs';
import Chart from './part/Chart';
import Error from '../../components/Error/Error';
import { MoulinetteLog } from '../../models/moulinetteLog';

export default function BullsScreen() {
	const [datas, setDatas] = useState<MoulinetteLog[]>([]); // Datas liées aux moulinettes éxecutées
	const [isLoad, setIsLoad] = useState(true); // loading state
	const [error, setError] = useState(false); // error state

	useEffect(() => {
		const requestOptions = {
			method: 'GET',
			headers: {
				Authorization: `JWT ${localStorage.getItem('token')}`,
			},
		};

		request<MoulinetteLog[]>('/sqlite-processes/', requestOptions)
			.then((logs: MoulinetteLog[]) => {
				if (!logs.length) return setError(true);
				setDatas(logs);
				setIsLoad(false);
			})
			.catch((error) => {
				setError(true);
			});
	}, []);

	return (
		<Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={1}>
				<Grid size={12}>
					<Paper
						sx={{
							p: 2,
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<Typography component="h2" variant="h4" color={'primary'} gutterBottom sx={{ mb: 2 }}>
							GTRX_SQLite - Moulinette taureaux
						</Typography>
						{error && <Error message="Une erreur est survenue lors de la récupération des données. Veuillez contacter l'administrateur." />}
					</Paper>
				</Grid>
				<Grid size={12}>
					{!isLoad && datas.length && (
						<Grid container spacing={3}>
							{/* Chart */}
							<Grid size={12}>
								<Paper
									sx={{
										p: 2,
										display: 'flex',
										flexDirection: 'column',
										height: 240,
									}}
								>
									<Chart datas={datas} />
								</Paper>
							</Grid>
						</Grid>
					)}
				</Grid>
				{/* Recent Logs */}
				<Grid size={12}>
					{!isLoad && datas.length && (
						<Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
							<TabLogs datas={datas} />
						</Paper>
					)}
				</Grid>
			</Grid>
		</Container>
	);
}
